var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('center',[_c('h1',[_vm._v("Not Found")]),_c('p',[_vm._v("This is not the droid you are looking for...")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }